/* DIVETTA MILANO — Home quality/trust owner, 02SEP2026.
   Builds the 15-indicator Home rails from the canonical scoped registry. */
(() => {
  'use strict';
  const OWNER = 'home-quality-trust-02sep2026-r1';
  const ROOT = '[data-ld-home-film][data-dv2-home]';
  const WORLDS = Object.freeze(['viso', 'capelli', 'corpo', 'makeup']);
  const IDS = Object.freeze([
    'nut_free', 'cruelty_free', 'pba', 'lot_traceability', 'gmp',
    'bureau_veritas', 'vegan', 'gluten_free', 'fda_registered',
    'cosmos_natural', 'cosmos_organic', 'dermatologically_tested',
    'allergen_label_free', 'fragrance_free', 'cpnp_registered'
  ]);
  let frame = 0;

  const esc = (value) => window.CSS?.escape
    ? window.CSS.escape(String(value))
    : String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');

  const records = () => IDS.map((id) => {
    const item = Array.from(document.querySelectorAll(`[data-ld-cert-item="${esc(id)}"]`))
      .find((candidate) => !candidate.closest('.ld-home-film__quality-list') && candidate.querySelector('[data-ld-cert-open]'));
    const trigger = item?.querySelector('[data-ld-cert-open]');
    const icon = item?.querySelector('.ld-home-film__cert-icon')?.innerHTML;
    const label = item?.querySelector('.ld-home-film__cert-label')?.textContent?.trim();
    const type = item?.querySelector('.ld-home-film__cert-type')?.textContent?.trim();
    const dialogId = trigger?.getAttribute('aria-controls')?.trim();
    return icon && label && type && dialogId ? { id, icon, label, type, dialogId } : null;
  });

  const card = (record, index) => {
    const item = document.createElement('li');
    item.className = 'ld-home-film__quality-badge';
    item.dataset.ldQualityBadge = '';
    item.dataset.ldQualityRuntime = 'true';
    item.dataset.ldCertItem = record.id;
    item.dataset.badgeIndex = String(index);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ld-home-film__quality-action';
    button.dataset.ldCertOpen = '';
    button.dataset.ldCertId = record.id;
    button.dataset.ldCertCategory = 'home';
    button.setAttribute('aria-controls', record.dialogId);
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-label', `${record.label}. ${record.type.toLocaleLowerCase('it-IT')}. Apri il perimetro dell’indicatore.`);

    const logo = document.createElement('span');
    logo.className = 'ld-home-film__quality-logo';
    logo.setAttribute('aria-hidden', 'true');
    logo.innerHTML = record.icon;

    const copy = document.createElement('span');
    copy.className = 'ld-home-film__quality-copy';
    const strong = document.createElement('strong');
    strong.textContent = record.label;
    const small = document.createElement('small');
    small.textContent = record.type;
    copy.append(strong, small);
    button.append(logo, copy);
    item.appendChild(button);
    return item;
  };

  const rebuild = (root = document.querySelector(ROOT)) => {
    if (!root?.matches?.(ROOT)) return false;
    const source = records();
    if (source.length !== 15 || source.some((record) => !record)) return false;
    const signature = source
      .map((record) => [record.id, record.label, record.type, record.dialogId].join('\u001f'))
      .join('\u001e');
    root.querySelectorAll('.ld-home-film__quality-list').forEach((list) => {
      if (list.dataset.ldQualitySignature !== signature) {
        list.replaceChildren(...source.map(card));
        list.dataset.ldQualitySignature = signature;
      }
      list.dataset.ldQualityRuntimeReady = 'true';
      list.dataset.ldQualityCount = '15';
      list.setAttribute('aria-label', '15 indicatori di qualità e trasparenza. Ogni indicatore specifica il proprio perimetro.');
      const heading = list.closest('.ld-home-film__quality')?.querySelector('.ld-home-film__quality-heading');
      if (heading) heading.textContent = '15 INDICATORI DI QUALITÀ E TRASPARENZA';
    });
    root.querySelectorAll('[data-ld-cert-item="b_corp"],[data-ld-cert-id="b_corp"],[data-ld-cert-item="b-corp"],[data-ld-cert-id="b-corp"]')
      .forEach((node) => node.remove());
    root.dataset.ldQualityRuntime = OWNER;
    const instance = window.DV2Home?.getInstance?.();
    window.setTimeout(() => {
      if (!instance || instance.destroyed) return;
      const visual = WORLDS.includes(instance.activeWorld) ? instance.visualFor?.(instance.activeWorld) : null;
      if (visual) instance.setupQualityMarqueeV11?.(visual);
    }, 0);
    return true;
  };

  const schedule = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => { frame = 0; rebuild(); });
  };

  const boot = () => rebuild();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('ld:home-release-controls-ready', schedule);
  const isExternalQualityMutation = (mutation) => {
    if (mutation.type === 'characterData') {
      const owner = mutation.target.parentElement?.closest?.('[data-ld-cert-item]');
      return Boolean(owner && !owner.closest('.ld-home-film__quality-list'));
    }
    return Array.from(mutation.addedNodes).some((node) => {
      if (!(node instanceof Element)) return false;
      const candidates = [];
      if (node.matches?.('[data-ld-cert-item],.ld-home-film__quality-list')) candidates.push(node);
      candidates.push(...node.querySelectorAll?.('[data-ld-cert-item],.ld-home-film__quality-list') || []);
      return candidates.some((candidate) =>
        candidate.matches('.ld-home-film__quality-list') || !candidate.closest('.ld-home-film__quality-list')
      );
    });
  };
  new MutationObserver((mutations) => {
    if (mutations.some(isExternalQualityMutation)) schedule();
  }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  window.addEventListener('pagehide', () => { if (frame) window.cancelAnimationFrame(frame); }, { once: true });
})();
